<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Gestion de Genre
      </h2>
    </div>
  </div>
  <CriteresRechercheGenre ref="criteresRechercheGenre" @rechercher="rechercher" @fermer="fermer"/>
  <ResultatRechercheGenre :genres="genres" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>
import ResultatRechercheGenre from "@/components/pilotage/ClassementDeDossier/ResultatRechercheGenre.vue";
import CriteresRechercheGenre from "@/components/pilotage/ClassementDeDossier/CriteresRechercheGenre.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "RechercherGenre",
  components: {
      ResultatRechercheGenre,
      CriteresRechercheGenre,
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
      isRechercheDataLoading: false,
      genres: [],
    }
  },
  mounted() {
    this.entite = Number(this.$route.params.entite)
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Genre");
  },
  methods: {
    rechercher(libelleRecherche) {
      this.genres = [];
      this.isRechercheDataLoading = true;

      this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
        res.data.libelles.forEach((currentEntite) => {
          currentEntite.tableValeur.libelles.forEach((currentGenre) => {
            let currentGenreComplet = currentGenre;
            currentGenreComplet.entite = currentEntite.tableValeur.cle
            currentGenreComplet.entiteDescription = currentEntite.tableValeur.description;
            this.genres.push(currentGenreComplet)
          })
        })
        this.isRechercheDataLoading = false;
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>